"use client";

import React from "react";
import "./CareerHero.scss";

import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ReactComponent as HeroBtnTag } from "../../assets/svg/heroBtnTag.svg";
import { ReactComponent as SideBtn } from "../../assets/svg/side-btn.svg";

import careerHero1 from "../../assets/images/careerHero1.png";

const CareerHero = () => {
  return (
    <section className="section careerHero">
      <article className="careerHero__container container">
        <div className="careerHero__container--header">
          <motion.button
            className="career__btn-up"
            type="button"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1 }}
          >
            <motion.span
              initial={{ y: 20, opacity: 0, scale: 1.15 }}
              animate={{ y: 0, opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              Careers
            </motion.span>

            <motion.div
              initial={{ y: 20, opacity: 0, scale: 1.15 }}
              animate={{ y: 0, opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              <HeroBtnTag />
            </motion.div>
          </motion.button>

          <div className="careerHero__container--header-title">
            <motion.h2
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Career with
            </motion.h2>
            <motion.h3
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1, delay: 0.4 }}
            >
              — Radiksez..
            </motion.h3>
          </div>

          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, delay: 1.2 }}
            className="contactHero__container--header-subtitle"
          >
            Looking for a career that&apos; all about making, shaping, and
            celebrating the extraordinary? then you are home!
          </motion.p>

          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, delay: 1.4 }}
          >
            <Link
              href="#join-team"
              className="careerHero__container--header-link"
            >
              <button className="career__btn-down ">
                <span> Join Our Team</span>
              </button>
              <SideBtn />
            </Link>
          </motion.div>
        </div>

        <figure className="careerHero__container--contents">
          <img
            src={careerHero1}
            alt="career"
            width={1256}
            height={649}
            title="Radiksez career image"
          />
        </figure>
      </article>
    </section>
  );
};

export default CareerHero;
